import { IProductAccessoryPayment } from "../../../@types/IProduct/IProductAccessory";
import { currencyFormatter } from "../../../utils/format";
import { useContext } from "react";
import PaymentContext from "../../../store/PaymentContext";
import styles from "./style.module.scss";
import LineItem from "../Invoice/LineItem";
import moment from "moment";
import { checkHasData, checkIsFullSet } from "../util";

const Rent = () => {
    const { rentCarts, rentTransportFee, rentDepositFee, discountFee, rentTotal, rentSurchargeFee, rentCustomer, orderSuccess } = useContext(PaymentContext);

    const rent = (rentTotal ?? 0)
        + (rentDepositFee ?? 0)
        + (rentSurchargeFee ?? 0)
        + (rentTransportFee ?? 0)

    return checkHasData(rentCarts) ? (
        <div className="cart-box rounded p-4 w-full">
            <div className={`flex justify-between ${styles.textBig}`}>
                <span>#Đơn thuê {orderSuccess?.rent_order_id}</span>
                <span>{currencyFormatter.format(rent)}</span>
            </div>

            <div className="flex gap-4">
                <span>{moment().format("DD-MM-YYYY")}</span>
                <span>|</span>
                <span>Thanh toán khi nhận hàng</span>
            </div>

            <div className="flex gap-4">
                Ngày thuê: {moment(rentCarts[0].take_date).format("DD-MM-YYYY")} - Ngày trả: {moment(rentCarts[0].return_date).format("DD-MM-YYYY")}
            </div>
            {/*<div className="">*/}
            {/*    Chi nhánh: Địa chỉ.......-Q10*/}
            {/*</div>*/}
            <LineItem className="mt-4" />

            <div className="py-4">
                {
                    rentCarts.map((item: any, index) => {
                        //if (!item.checked) return null;

                        // if(item.accessories?.length) {
                        //     let accessoriesChecked = item.accessories?.filter((acc: IProductAccessoryPayment) => acc.checked);


                        //     return accessoriesChecked?.length > 0 && (
                        //         <div key={index}>
                        //             <div className="flex justify-between">
                        //                 <div className="bold">{ item.name }</div>
                        //             </div>
                        //             {
                        //                 accessoriesChecked.map((acc: IProductAccessoryPayment, accIndex: number) => (
                        //                     <div key={`${index}_${accIndex}`} className="flex justify-between ml-4">
                        //                         <div>{ acc.name } <sup>x {acc.qty}</sup></div>
                        //                         <div className="text-right">{ currencyFormatter.format((acc.rental_price ?? 0) * (acc.qty ?? 0)) }</div>
                        //                     </div>
                        //                 ))
                        //             }
                        //         </div>
                        //     )
                        // }

                        // return (
                        //     <div key={index} className="flex justify-between">
                        //         <div className="bold">{ item.name } <sup>x {item.qty}</sup></div>
                        //         <div className="text-right">{ currencyFormatter.format((item.rental_price ?? 0) * (item.qty ?? 0)) }</div>
                        //     </div>
                        // )

                        let isFull = checkIsFullSet(item)
                        let accessoriesChecked = item.accessories?.filter((acc: IProductAccessoryPayment) => acc.checked);

                        if (item?.is_product === false) {


                            return <>
                                {item.checked && <div key={index} className="flex flex-row justify-between">
                                    <div>{item.name} <sup>x {item.qty}</sup></div>
                                    <div className="text-right">{currencyFormatter.format(item.rental_price)}</div>
                                </div>}
                                {
                                    accessoriesChecked.map((acc: IProductAccessoryPayment, accIndex: number) => (
                                        <div key={`${index}_${accIndex}`} className={"flex flex-row justify-between ml-4"}>
                                            <div>{acc.name} <sup>x {acc.qty}</sup></div>
                                            {/* <div className="text-right">{currencyFormatter.format(acc.price ?? 0)}</div> */}
                                        </div>
                                    ))
                                }
                            </>
                        }

                        if ((!item.checked && item.allowed_split && accessoriesChecked?.length > 0) || (item.checked && item.allowed_split && accessoriesChecked?.length === 1)) {

                            return accessoriesChecked?.length > 0 && (
                                <div key={index}>
                                    <div key={index} className="flex justify-between">
                                        <div>{item.name} </div>
                                        {/* <div className="text-right">{currencyFormatter.format(item.rental_price ?? 0)}</div> */}
                                    </div>
                                    {
                                        accessoriesChecked.map((acc: IProductAccessoryPayment, accIndex: number) => (
                                            <div key={`${index}_${accIndex}`} className={"flex flex-row justify-between ml-4 "}>
                                                <div>{acc.name} <sup>x {acc.qty}</sup></div>
                                                <div className="text-right">{currencyFormatter.format(acc.rental_price ?? 0)}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            )
                        }

                        if (item.accessories?.length && !isFull) {

                            return accessoriesChecked?.length > 0 && (
                                <div key={index}>
                                    <div className="flex flex-row justify-between">
                                        <div>{item.name}</div>
                                        <div className="text-right">{currencyFormatter.format(item.price)}</div>
                                    </div>
                                    {
                                        accessoriesChecked.map((acc: IProductAccessoryPayment, accIndex: number) => (
                                            <div key={`${index}_${accIndex}`} className={"flex flex-row justify-between " + (isFull ? "ml-4" : "")}>
                                                <div>{acc.name} <sup>x {acc.qty}</sup></div>
                                                <div className="text-right">{currencyFormatter.format(acc.rental_price ?? 0)}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            )
                        }

                        //console.log("test", accessoriesChecked);
                        return (
                            <>
                                {item.checked && <div key={index} className="flex flex-row justify-between">
                                    <div>{item.name} <sup>x {item.qty}</sup></div>
                                    <div className="text-right">{currencyFormatter.format(item.rental_price ?? 0)}</div>
                                </div>}

                                {
                                    accessoriesChecked?.map((acc: any, accIndex: number) => {
                                        if (acc.bundling_id) {
                                            return <div key={`${index}_${accIndex}`} className={"flex flex-row justify-between " + (item.checked ? "ml-4" : "")}>
                                                <div>{acc.name} <sup>x {acc.qty}</sup></div>
                                                <div className="text-right">{currencyFormatter.format(acc.rental_price ?? 0)}</div>
                                            </div>
                                        }
                                        if (acc.qty > item.qty) {
                                            return <div key={`${index}_${accIndex}`} className={"flex flex-row justify-between " + (item.checked ? "ml-4" : "")}>
                                                <div>{acc.name} <sup>x {acc.qty - item.qty}</sup></div>
                                                <div className="text-right">{currencyFormatter.format(acc.rental_price ?? 0)}</div>
                                            </div>
                                        }

                                        return <>
                                        </>
                                    })
                                }
                            </>
                        )
                    })
                }

                <div className="flex justify-between mt-4">
                    <span>Phí phụ thu</span>
                    <span>{currencyFormatter.format(rentSurchargeFee ?? 0)}</span>
                </div>
                <div className="flex justify-between">
                    <span>Phí đảm bảo</span>
                    <span>{currencyFormatter.format(rentDepositFee ?? 0)}</span>
                </div>
                <div className="flex justify-between">
                    <span>Phí giao hàng</span>
                    <span>{currencyFormatter.format(rentTransportFee ?? 0)}</span>
                </div>
                <div className="flex justify-between">
                    <span>Giảm giá</span>
                    <span>{currencyFormatter.format(discountFee ?? 0)}</span>
                </div>
                <div className="flex justify-between mt-4">
                    <textarea value={rentCustomer.note ? `Ghi chú: ${rentCustomer.note}` : ''} readOnly={true} placeholder={'Ghi chú'} className="w-full rounded border-0 text-sm" />
                    {/*<span>Ghi chú</span>*/}
                    {/*<span>{ rentCustomer.note }</span>*/}
                </div>
            </div>
        </div>
    ) : null
}

export default Rent;
